module.exports = __webpack_public_path__ + "img/icon_4_39.f4b5dbb1.png";